// Vocabulaire fermé et contrôles déterministes : les garde-fous ne dépendent jamais du modèle.
import { z } from 'zod';
import { CATEGORIES_CONVERSATION, normaliserRecherche } from './boite-reception.js';
export const MOTIFS_SENSIBLES = [
    'negociation',
    'authenticite',
    'provenance',
    'litige',
    'plainte',
    'presse_delicate',
];
export const TERMES_SENSIBLES = {
    negociation: [
        'remise',
        'négociation',
        'négocier',
        'rabais',
        'discount',
        'negotiation',
        'negotiate',
    ],
    authenticite: ['authenticité', 'authentique', 'authenticity', 'authentic', 'faux', 'forgery'],
    provenance: [
        'provenance contestée',
        'provenance contestee',
        'disputed provenance',
        'stolen',
        'volée',
    ],
    litige: ['litige', 'avocat', 'procès', 'lawsuit', 'lawyer', 'dispute', 'attorney'],
    plainte: ['plainte', 'réclamation', 'complaint', 'complain'],
    presse_delicate: [
        'presse délicate',
        'scandale',
        'polémique',
        'sensitive press',
        'scandal',
        'controversy',
    ],
};
export const SUJETS_PRATIQUES = ['horaires', 'adresse', 'exposition_en_cours'];
export const MOTS_INTERDITS_REPONSE_PRATIQUE = [
    'prix',
    'tarif',
    'coût',
    'euros',
    'euro',
    'dollars',
    'dollar',
    'livres',
    'price',
    'cost',
    'pricing',
    'disponible',
    'disponibilité',
    'réservée',
    'réserver',
    'vendue',
    'available',
    'availability',
    'reserved',
    'sold',
    'remise',
    'négociation',
    'négocier',
    'rabais',
    'discount',
    'negotiate',
    'negotiation',
];
export function contientTerme(texte, terme) {
    const mots = normaliserRecherche(terme).match(/[\p{L}\p{N}]+/gu);
    if (!mots?.length)
        return false;
    return new RegExp(`(?:^|[^\\p{L}\\p{N}])${mots.join('[^\\p{L}\\p{N}]+')}(?:$|[^\\p{L}\\p{N}])`, 'u').test(normaliserRecherche(texte));
}
export function motifsDeterministes(texte, termes = [], exclus = []) {
    return [
        ...MOTIFS_SENSIBLES.filter((m) => TERMES_SENSIBLES[m].some((t) => contientTerme(texte, t))),
        ...(termes.some((t) => contientTerme(texte, t)) ? ['terme_galerie'] : []),
        ...(exclus.some((t) => contientTerme(texte, t)) ? ['sujet_exclu'] : []),
    ];
}
export function textePratiqueSur(texte) {
    // Refus conservateur des chiffres : une quantité ne doit pas masquer un montant sans devise.
    return (texte.trim().length > 0 &&
        texte.length <= 1200 &&
        !/[\d\p{Sc}]/u.test(texte) &&
        !MOTS_INTERDITS_REPONSE_PRATIQUE.some((m) => contientTerme(texte, m)));
}
export const triAssistantSchema = z.strictObject({
    categorie: z.enum([...CATEGORIES_CONVERSATION, 'indesirable']),
    urgence: z.enum(['haute', 'normale', 'basse']),
    sensible: z.boolean(),
    motifsSensibles: z.array(z.enum(MOTIFS_SENSIBLES)).max(6),
    pratique: z.boolean(),
    sujetsPratiques: z.array(z.enum(SUJETS_PRATIQUES)).max(3),
    langue: z.enum(['fr', 'en', 'autre']),
    resume: z.string().max(200),
});
export const brouillonAssistantSchema = z.strictObject({
    texte: z.string().trim().min(1).max(12000),
    langue: z.enum(['fr', 'en']),
    oeuvresCitees: z.array(z.string()).max(5),
    aVerifier: z.array(z.string().max(500)).max(20),
});
export const pratiqueAssistantSchema = z.strictObject({
    repondable: z.boolean(),
    texte: z.string().max(12000),
});
export const reglagesAssistantSchema = z.strictObject({
    triActif: z.boolean().default(true),
    brouillonsAutomatiques: z
        .strictObject({
        actif: z.boolean().default(false),
        categories: z.array(z.enum(CATEGORIES_CONVERSATION)).max(7).default([]),
    })
        .default({ actif: false, categories: [] }),
    prixParEcrit: z.boolean().default(false),
    termesSensibles: z.array(z.string().trim().min(1).max(60)).max(50).default([]),
    reponsesPratiques: z
        .strictObject({
        actif: z.boolean().default(false),
        sujets: z.array(z.enum(SUJETS_PRATIQUES)).max(3).default([]),
    })
        .default({ actif: false, sujets: [] }),
    relances: z
        .strictObject({
        actif: z.boolean().default(true),
        delaiJours: z.int().min(3).max(30).default(7),
        offres: z.boolean().default(true),
        vernissages: z.boolean().default(true),
    })
        .default({ actif: true, delaiJours: 7, offres: true, vernissages: true }),
});
export const modificationAssistantSchema = reglagesAssistantSchema.extend({
    version: z.int().min(0),
    confirmationAutomatique: z.boolean().optional(),
});
export const essaiAssistantSchema = z.union([
    z.strictObject({ conversationId: z.string().regex(/^[a-f\d]{24}$/i) }),
    z.strictObject({ texte: z.string().trim().min(1).max(4000) }),
]);
//# sourceMappingURL=assistant-reponse.js.map